// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Dashboard20 from './Dashboard20';
import Dashboard24 from './Dashboard24';

type DashboardProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Dashboard20,
    Dashboard24,
};

const Dashboard: FC<DashboardProps> = ({ variation, ...props }) => {
    const variationKey = `Dashboard${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Dashboard" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Dashboard;
